import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Twitch: IconNode = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7' }]],
];

export default Twitch;
